(function () {
  const DISABLED_CLASS = 'disabled';

  function updateNavButtons(swiper, section) {
    var prevBtn = section.querySelector('.prev-button-trigger');
    var nextBtn = section.querySelector('.next-button-trigger');
    if (prevBtn) prevBtn.classList.toggle(DISABLED_CLASS, swiper.isBeginning);
    if (nextBtn) nextBtn.classList.toggle(DISABLED_CLASS, swiper.isEnd);
  }

  function updateNavVisibility(swiper) {
    var slidesCount = swiper.slides.length;
    var slidesPerView = parseFloat(swiper.params.slidesPerView, 10);
    var needsNav = slidesCount > slidesPerView;
    var section = swiper.el.closest('.section-news-slider');
    if (section) section.classList.toggle('news-slider--no-nav', !needsNav);
  }

  function initNewsSliders() {
    const sliders = document.querySelectorAll('[data-news-slider]');
    if (!sliders.length || typeof Swiper === 'undefined') return;

    sliders.forEach(function (el) {
      if (el.swiper) return;
      var slides = el.querySelectorAll('.swiper-slide');
      if (!slides.length) return;

      var section = el.closest('.section-news-slider');
      var prevTrigger = section ? section.querySelector('.prev-button-trigger') : null;
      var nextTrigger = section ? section.querySelector('.next-button-trigger') : null;

      var swiper = new Swiper(el, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 24
          }
        },
        pagination: {
          el: el.querySelector('.news-slider-list__pagination'),
          clickable: true
        },
        navigation: {
          nextEl: el.querySelector('.news-slider-list__next'),
          prevEl: el.querySelector('.news-slider-list__prev')
        },
        on: {
          init: function () {
            updateNavButtons(this, section);
            updateNavVisibility(this);
          },
          slideChange: function () {
            updateNavButtons(this, section);
          },
          breakpointChange: function () {
            updateNavVisibility(this);
          }
        }
      });

      if (prevTrigger) {
        prevTrigger.addEventListener('click', function () {
          if (!swiper.isBeginning) swiper.slidePrev();
        });
      }
      if (nextTrigger) {
        nextTrigger.addEventListener('click', function () {
          if (!swiper.isEnd) swiper.slideNext();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsSliders);
  } else {
    initNewsSliders();
  }

  document.addEventListener('shopify:section:load', initNewsSliders);
})();
